export default __webpack_public_path__ + "static/media/university design.93999c2d.png";